<template>
  <div style="font-size: 14px">
    <div class="case-pice">
      <span class="case-pice-first">报名记录</span>
      <span class="case-pice-and">/</span>
      <span class="case-pice-second">修改报名记录</span>
    </div>
    <div class="common-title">
      基本信息
      <el-button
        style="float: right; margin-left: 10px"
        size="small"
        type="info"
        @click="goBack()"
        plain
        >返回
      </el-button>
      <el-button
        style="float: right"
        size="small"
        type="primary"
        @click="saveData()"
        plain
        >保存</el-button
      >
    </div>
    <div
      style="height: calc(100vh - 185px); overflow-y: auto; overflow-x: hidden"
    >
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">学员姓名：</div>
            <el-input
              v-model="signUpData.name"
              clearable
              class="grid-input"
              size="small"
              placeholder="请输入学员姓名"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">性别：</div>
            <el-select
              size="small"
              class="grid-input"
              clearable
              v-model="signUpData.sex"
              placeholder="请选择性别"
            >
              <el-option
                v-for="item in sexList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">手机号码：</div>
            <el-input
              v-model="signUpData.phone"
              clearable
              class="grid-input"
              size="small"
              placeholder="请输入手机号码"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">培训类别：</div>
            <el-select
              size="small"
              class="grid-input"
              disabled
              clearable
              v-model="signUpData.trainingClasses"
              placeholder="请选择培训类别"
            >
              <el-option
                v-for="item in tarinTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">专业类别：</div>
            <el-select
              size="small"
              class="grid-input"
              clearable
              v-model="signUpData.professionalClasses"
              placeholder="请选择专业类别"
            >
              <el-option
                v-for="(item, index) in majorCategoryList"
                :key="index"
                :label="item.codeCname"
                :value="item.codeCode"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">培训人员：</div>
            <el-select
              size="small"
              class="grid-input"
              clearable
              v-model="signUpData.trainers"
              placeholder="请选择培训人员"
            >
              <el-option
                v-for="item in trainersList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">证件类型：</div>
            <el-select
              size="small"
              class="grid-input"
              clearable
              v-model="signUpData.idType"
              placeholder="请选择证件类型"
            >
              <el-option
                v-for="item in cardTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">证件号码：</div>
            <el-input
              v-model="signUpData.idCard"
              clearable
              class="grid-input"
              size="small"
              placeholder="请输入证件号码"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">学历：</div>
            <el-select
              size="small"
              class="grid-input"
              clearable
              v-model="signUpData.education"
              placeholder="请选择学历"
            >
              <el-option
                v-for="item in educationList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">健康状况：</div>
            <el-select
              size="small"
              class="grid-input"
              clearable
              v-model="signUpData.healthState"
              placeholder="请选择健康状况"
            >
              <el-option
                v-for="item in healthList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">出生日期：</div>
            <div style="flex: 1">
              <el-date-picker
                size="small"
                style="width: 100%"
                v-model="signUpData.birthday"
                type="date"
                placeholder="请选择出生日期"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">民族：</div>
            <div style="flex: 1">
              <el-select
                size="small"
                class="common-full-width"
                v-model="signUpData.nation"
                clearable
                placeholder="请选择民族"
              >
                <el-option
                  v-for="item in nationList"
                  :key="item.cc"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">专业技术职务：</div>
            <div style="flex: 1">
              <el-select
                size="small"
                class="common-full-width"
                v-model="signUpData.technicalPosition"
                clearable
                placeholder="请选择专业技术职务"
              >
                <el-option
                  v-for="item in technicalList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">电子邮箱：</div>
            <el-input
              v-model="signUpData.email"
              clearable
              class="grid-input"
              size="small"
              placeholder="请输入邮箱地址"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">受聘时间：</div>
            <div style="flex: 1">
              <el-date-picker
                size="small"
                style="width: 100%"
                v-model="signUpData.employedDate"
                type="date"
                placeholder="请选择受聘时间"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">毕业院校：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.graduateSchool"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入毕业院校"
              ></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">毕业时间：</div>
            <div style="flex: 1">
              <el-date-picker
                size="small"
                style="width: 100%"
                v-model="signUpData.graduationDate"
                type="date"
                placeholder="请选择毕业时间"
              ></el-date-picker>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">通讯地址：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.homeAddress"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入通讯地址"
              ></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">专业：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.major"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入专业"
              ></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">学位：</div>
            <div style="flex: 1">
              <el-select
                size="small"
                class="common-full-width"
                v-model="signUpData.degree"
                clearable
                placeholder="请选择学位"
              >
                <el-option
                  v-for="item in degreeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">考试科目：</div>
            <div style="flex: 1">
              <el-select
                size="small"
                class="common-full-width"
                v-model="signUpData.examSubject"
                clearable
                placeholder="请选择考试科目"
              >
                <el-option
                  v-for="item in examSubjectList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">证书邮寄地址：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.mailingAddress"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入证书邮寄地址"
              ></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">收件人：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.recipients"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入收件人"
              ></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">联系电话：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.recipientsPhone"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入收件人联系电话"
              ></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label" style="width: 200px">
              累计从事道路运输工作年限：
            </div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.yearsOfWorking"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入累计从事道路运输工作年限"
              ></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8"> </el-col>
        <el-col :span="8"> </el-col>
      </el-row>
      <div class="common-title">请选择会员单位</div>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content">
            <div class="grid-label">单位名称：</div>
            <el-input
              v-model="signUpData.companyName"
              clearable
              class="grid-input"
              size="small"
              placeholder="请输入单位名称"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="openModel()"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">企业所属区县：</div>
            <el-input
              v-model="signUpData.companyAddress"
              clearable
              class="grid-input"
              size="small"
              @clear="handleClear"
              placeholder="企业所属区县"
              v-if="selectedOptions.length == 0"
            ></el-input>
            <el-cascader
              class="common-input-long-width"
              size="small"
              :options="areaList"
              v-model="selectedOptions"
              :props="setProps"
              ref="myCascader"
              v-else
            ></el-cascader>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">统一社会代码：</div>
            <el-input
              v-model="signUpData.creditCode"
              clearable
              class="grid-input"
              size="small"
              placeholder="统一社会代码"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">法人：</div>
            <el-input
              v-model="signUpData.corp"
              clearable
              class="grid-input"
              size="small"
              placeholder="法人"
            >
            </el-input>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content">
            <div class="grid-label">营业执照地址：</div>
            <el-input
              v-model="signUpData.businessAddress"
              clearable
              class="grid-input"
              size="small"
              placeholder="营业执照地址"
            ></el-input>
            <!--<div>{{signUpData.businessAddress}}</div>-->
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">联系人：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.companyContacts"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入联系人名称"
              ></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">联系人电话：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.companyContactsPhone"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入联系人电话"
              ></el-input>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">邮编：</div>
            <div style="flex: 1">
              <el-input
                v-model="signUpData.postcode"
                clearable
                class="common-full-width"
                size="small"
                placeholder="请输入邮编"
              ></el-input>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="common-title">请上传图片</div>
      <div
        style="display: flex; justify-content: space-between; cursor: pointer"
        id="imgTooles"
      >
        <div style="width: 250px; height: 290px; text-align: center">
          <div
            style="
              width: 240px;
              height: 240px;
              border: 1px solid #eeeeee;
              position: relative;
              margin-bottom: 10px;
              overflow: hidden;
            "
          >
            <i
              v-if="signUpData.businessLicenseImg != ''"
              class="el-icon-circle-close img-close-icon"
              @click="deleteImg('businessLicenseImg')"
            ></i>
            <img
              @click="preImage()"
              :src="signUpData.businessLicenseImg"
              style="width: 100%; height: auto"
              alt=""
              :data-original="signUpData.businessLicenseImg"
            />
          </div>
          <el-upload
            :headers="$util.getUploadHeaders()"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
            :action="actionUrl"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">上传营业执照</el-button>
          </el-upload>
        </div>
        <div style="width: 250px; height: 290px; text-align: center">
          <div
            style="
              width: 240px;
              height: 240px;
              border: 1px solid #eeeeee;
              position: relative;
              margin-bottom: 10px;
              overflow: hidden;
            "
          >
            <i
              v-if="signUpData.vipFormImg != ''"
              class="el-icon-circle-close img-close-icon"
              @click="deleteImg('vipFormImg')"
            ></i>
            <img
              @click="preImage()"
              :src="signUpData.vipFormImg"
              style="width: 100%; height: auto"
              alt=""
              :data-original="signUpData.vipFormImg"
            />
          </div>
          <el-upload
            :headers="$util.getUploadHeaders()"
            :before-upload="beforeAvatarUpload"
            :on-success="handleMeberSuccess"
            :action="actionUrl"
            :show-file-list="false"
          >
            <el-button size="small" type="primary"
              >上传会员单位申请表</el-button
            >
          </el-upload>
        </div>
        <div style="width: 250px; height: 290px; text-align: center">
          <div
            style="
              width: 240px;
              height: 240px;
              border: 1px solid #eeeeee;
              position: relative;
              margin-bottom: 10px;
              overflow: hidden;
            "
          >
            <i
              v-if="signUpData.transportLicenseImg != ''"
              class="el-icon-circle-close img-close-icon"
              @click="deleteImg('transportLicenseImg')"
            ></i>
            <img
              @click="preImage()"
              :src="signUpData.transportLicenseImg"
              style="width: 100%; height: auto"
              alt=""
              :data-original="signUpData.transportLicenseImg"
            />
          </div>
          <el-upload
            :headers="$util.getUploadHeaders()"
            :before-upload="beforeAvatarUpload"
            :on-success="handleRoadSuccess"
            :action="actionUrl"
            :show-file-list="false"
          >
            <el-button size="small" type="primary"
              >上传道路运输许可证</el-button
            >
          </el-upload>
        </div>
        <div style="width: 250px; height: 290px; text-align: center">
          <div
            style="
              width: 240px;
              height: 240px;
              border: 1px solid #eeeeee;
              position: relative;
              margin-bottom: 10px;
              overflow: hidden;
            "
          >
            <i
              v-if="signUpData.appointmentImg != ''"
              class="el-icon-circle-close img-close-icon"
              @click="deleteImg('appointmentImg')"
            ></i>
            <img
              @click="preImage()"
              :src="signUpData.appointmentImg"
              style="width: 100%; height: auto"
              alt=""
              :data-original="signUpData.appointmentImg"
            />
          </div>
          <el-upload
            :headers="$util.getUploadHeaders()"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAppointSuccess"
            :action="actionUrl"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">上传总经理任命书</el-button>
          </el-upload>
        </div>
      </div>
      <div
        style="display: flex; justify-content: space-between; cursor: pointer"
        id="imgTooles1"
      >
        <div style="width: 250px; height: 290px; text-align: center">
          <div
            style="
              width: 240px;
              height: 240px;
              border: 1px solid #eeeeee;
              position: relative;
              margin-bottom: 10px;
              overflow: hidden;
            "
          >
            <i
              v-if="signUpData.personImg != ''"
              class="el-icon-circle-close img-close-icon"
              @click="deleteImg('personImg')"
            ></i>
            <img
              @click="preImage2()"
              :src="signUpData.personImg"
              style="width: 100%; height: auto"
              alt=""
              :data-original="signUpData.personImg"
            />
          </div>
          <el-upload
            :headers="$util.getUploadHeaders()"
            :before-upload="beforeAvatarUpload"
            :on-success="handlePersonSuccess"
            :action="actionUrl"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">上传学员证件照片</el-button>
          </el-upload>
        </div>
        <div style="width: 250px; height: 290px; text-align: center">
          <div
            style="
              width: 240px;
              height: 240px;
              border: 1px solid #eeeeee;
              position: relative;
              margin-bottom: 10px;
              overflow: hidden;
            "
          >
            <i
              v-if="signUpData.idCardFrontImg != ''"
              class="el-icon-circle-close img-close-icon"
              @click="deleteImg('idCardFrontImg')"
            ></i>
            <img
              @click="preImage2()"
              :src="signUpData.idCardFrontImg"
              style="width: 100%; height: auto"
              alt=""
              :data-original="signUpData.idCardFrontImg"
            />
          </div>
          <el-upload
            :headers="$util.getUploadHeaders()"
            :before-upload="beforeAvatarUpload"
            :on-success="handleFrontSuccess"
            :action="actionUrl"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">上传证件正面照</el-button>
          </el-upload>
        </div>
        <div style="width: 250px; height: 290px; text-align: center">
          <div
            style="
              width: 240px;
              height: 240px;
              border: 1px solid #eeeeee;
              position: relative;
              margin-bottom: 10px;
              overflow: hidden;
            "
          >
            <i
              v-if="signUpData.idCardBackImg != ''"
              class="el-icon-circle-close img-close-icon"
              @click="deleteImg('idCardBackImg')"
            ></i>
            <img
              @click="preImage2()"
              :src="signUpData.idCardBackImg"
              style="width: 100%; height: auto"
              alt=""
              :data-original="signUpData.idCardBackImg"
            />
          </div>
          <el-upload
            :headers="$util.getUploadHeaders()"
            :before-upload="beforeAvatarUpload"
            :on-success="handleBackSuccess"
            :action="actionUrl"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">上传证件背面照</el-button>
          </el-upload>
        </div>
        <div style="width: 250px; height: 290px; text-align: center"></div>
      </div>
      <div class="common-title">安全证书</div>
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content">
            <div class="grid-label">安全证书编号：</div>
            <el-input
              v-model="signUpData.certificationNo"
              clearable
              class="grid-input"
              size="small"
              placeholder="请输入安全证书编号"
            ></el-input>
          </div>
        </el-col>
      </el-row>
      <div
        style="
          width: 250px;
          height: 290px;
          text-align: center;
          margin-top: 10px;
        "
      >
        <div
          style="
            width: 240px;
            height: 240px;
            border: 1px solid #eeeeee;
            position: relative;
            margin-bottom: 10px;
            overflow: hidden;
          "
        >
          <i
            v-if="signUpData.safetyCertificateImg != ''"
            class="el-icon-circle-close img-close-icon"
            @click="deleteImg('safetyCertificateImg')"
          ></i>
          <img
            @click="preImage11()"
            :src="signUpData.safetyCertificateImg"
            style="width: 100%; height: auto"
            alt=""
            id="imgToolesSafe"
            :data-original="signUpData.safetyCertificateImg"
          />
        </div>
        <el-upload
          :headers="$util.getUploadHeaders()"
          :before-upload="beforeAvatarUpload"
          :on-success="handleSafeSuccess"
          :action="actionUrl"
          :show-file-list="false"
        >
          <el-button size="small" type="primary">上传安全证书</el-button>
        </el-upload>
      </div>
    </div>
    <el-dialog
      title="选择会员单位"
      :visible.sync="dialogBillVisible"
      v-if="dialogBillVisible"
      width="80%"
    >
      <div class="commom-input-label">会员单位名称：</div>
      <el-input
        v-model="searchData.companyName"
        clearable
        class="common-input-width"
        size="small"
        placeholder="请输入会员单位名称"
      ></el-input>
      <div class="commom-input-label" style="margin-left: 20px">
        统一社会代码：
      </div>
      <el-input
        v-model="searchData.creditCode"
        clearable
        class="common-input-width"
        size="small"
        placeholder="请输入统一社会代码"
      ></el-input>
      <el-button
        size="small"
        type="primary"
        style="margin-left: 10px; font-size: 14px"
        @click="search()"
        plain
        icon="el-icon-search"
        >查询</el-button
      >
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        stripe
        height=" calc(100vh - 440px)"
      >
        <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          min-width="200"
          show-overflow-tooltip
          label="会员单位名称"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          min-width="200"
          label="企业所属县区"
        >
          <template slot-scope="scope">
            {{ scope.row.provinceName }} - {{ scope.row.cityName }} -
            {{ scope.row.countyName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="businessAddress"
          min-width="200"
          show-overflow-tooltip
          label="营业执照地址"
        >
        </el-table-column>
        <el-table-column
          prop="companySource"
          min-width="100"
          show-overflow-tooltip
          label="来源"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.companySource == 1">学员申请</span>
            <span v-else>系统注册</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="160"
          prop="creditCode"
          show-overflow-tooltip
          label="统一社会代码"
        >
        </el-table-column>
        <el-table-column
          prop="corp"
          min-width="100"
          show-overflow-tooltip
          label="法人"
        >
        </el-table-column>
        <el-table-column
          prop="updateTime"
          min-width="160"
          show-overflow-tooltip
          label="更新时间"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="confirmSelect(scope.row)"
              plain
              >确定</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNumber"
        >
        </el-pagination>
      </div>
      <!--<div style="text-align:center;height: 50px;line-height: 50px;">
				<el-button size='small' type="primary" @click='defineSave()' plain>确定</el-button>
				<el-button size='small' type="info" @click='dialogBillVisible = false' plain>取消</el-button>
			</div>-->
    </el-dialog>
  </div>
</template>

<script>
import mapjson from "../../common/js/map";
import Viewer from "viewerjs";
import {
  getSignUpDetail,
  majorTypeList,
  uploadMaterial,
  companyList,
  appInfo,
  getDetailCompany,
  addCompany,
} from "../../api/main";
export default {
  data() {
    return {
      signUpData: {},
      areaList: mapjson,
      selectedOptions: [], // 预设的选中值
      props: { multiple: true },
      setProps: {
        expandTrigger: "click",
      },
      sexList: [
        {
          label: "男",
          value: "0",
        },
        {
          label: "女",
          value: "1",
        },
      ],
      tarinTypeList: [
        {
          label: "初次培训",
          value: "1",
        },
        {
          label: "继续教育",
          value: "2",
        },
      ],
      majorCategoryList: [],
      trainersList: [
        {
          label: "负责人",
          value: "1",
        },
        {
          label: "安全管理人员",
          value: "2",
        },
         {
					label: '动态监控',
					value: "3"
				}, {
					label: '其他',
					value: "4"
				}
      ],
      actionUrl: "",
      //				actionUrl: 'http://19940309.xyz:20005/api/v1/uploadMaterial',
      imageUrl: "",
      healthList: [
        {
          value: "1",
          name: "严重",
        },
        {
          value: "2",
          name: "一切正常",
        },
        {
          value: "3",
          name: "状况欠佳",
        },
      ],
      dialogBillVisible: false,
      searchData: {
        companyName: "",
        creditCode: "",
      },
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalNumber: 0,
      pullAddress: [],
      yingyeFileList: [],
      memberFileList: [],
      roadFileList: [],
      memberPageId:''
    };
  },
  computed: {
    cardTypeList() {
      let cardTypeList = JSON.parse(sessionStorage.getItem("cardTypeList"));
      cardTypeList.shift();
      return cardTypeList;
    },
    nationList() {
      let nationList = JSON.parse(sessionStorage.getItem("nationList"));
      nationList.shift();
      return nationList;
    },
    technicalList() {
      let technicalList = JSON.parse(sessionStorage.getItem("technicalList"));
      technicalList.shift();
      return technicalList;
    },
    degreeList() {
      let degreeList = JSON.parse(sessionStorage.getItem("degreeList"));
      degreeList.shift();
      return degreeList;
    },
    examSubjectList() {
      let examSubjectList = JSON.parse(
        sessionStorage.getItem("examSubjectList")
      );
      examSubjectList.shift();
      return examSubjectList;
    },
    educationList() {
      let educationList = JSON.parse(sessionStorage.getItem("educationList"));
      return educationList;
    },
  },
  mounted() {
    this.actionUrl = `${this.$httpUrl}/api/v1/uploadMaterial`;
    this.getDetail();
    this.getMajorDataList();
    this.getCompanyList();
  },
  methods: {
    saveData() {
      this.signUpData.applicationFormId = this.$store.state.signUpRecordId;
      var reg = new RegExp(
        "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
      );
      let flag = null;
      console.log(this.rulelist);
      flag = this.rulelist.find((value) => {
        if (!this.signUpData[value.str]) return value;
      });
      console.log(flag);
      if (flag) {
        let type;
        type = flag.type == 1 ? "请选择" : "请输入";
        this.$message({ type: "error", message: `${type}${flag.name}` });
        return;
      }
      var myreg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.signUpData.phone)) {
        this.$message({ type: "error", message: `手机号格式错误，请重新输入` });
        return;
      }
      if (!reg.test(this.signUpData.email)) {
        this.$message({ type: "error", message: `邮件格式错误，请重新输入` });
        return;
      }
      this.signUpData.birthday = this.$util.getNowDate(
        this.signUpData.birthday
      );
      this.signUpData.employedDate = this.$util.getNowDate(
        this.signUpData.employedDate
      );
      this.signUpData.graduationDate = this.$util.getNowDate(
        this.signUpData.graduationDate
      );
      if (this.selectedOptions.length != 0 && this.selectedOptions[0] != 1) {


        this.$nextTick(() => {
          this.signUpData.companyAddress = this.$refs.myCascader
          .getCheckedNodes()[0]
          .pathLabels.join(",");
    })
   


          
      }
      appInfo(this.signUpData).then((res) => {
        if (res.code == 1) {
          this.$message.success("修改成功！");
          if(this.pullAddress.length==3 &&this.yingyeFileList.length!=0 && this.memberFileList.length!= 0 && this.roadFileList.length!=0 ){
            this.updataCompany()
          }else{
            this.$router.push("/SignUpRecord");
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    confirmSelect(row) {
      this.signUpData.companyAddress =
        row.provinceName + row.cityName + row.countyName;
      this.signUpData.creditCode = row.creditCode;
      this.signUpData.corp = row.corp;
      this.signUpData.businessAddress = row.businessAddress;
      this.signUpData.companyName = row.companyName;
      this.signUpData.companyId = row.companyId;
      this.dialogBillVisible = false;
    },
    openModel() {
      this.dialogBillVisible = true;
    },
    search() {
      this.currentPage = 1;
      this.getCompanyList();
    },
    handleSizeChange(data) {
      this.pageSize = data;
      this.getCompanyList();
    },
    handleCurrentChange(data) {
      this.currentPage = data;
      this.getCompanyList();
    },
    getCompanyList() {
      companyList({
        companyName: this.searchData.companyName,
        creditCode: this.searchData.creditCode,
        current: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.totalNumber = parseInt(res.data.total);
        this.tableData = res.data.records;
      });
    },
    deleteImg(url) {
      if (url == "businessLicenseImg") {
        this.signUpData.businessLicenseImg = "";
      }
      if (url == "vipFormImg") {
        this.signUpData.vipFormImg = "";
      }
      if (url == "transportLicenseImg") {
        this.signUpData.transportLicenseImg = "";
      }
      if (url == "appointmentImg") {
        this.signUpData.appointmentImg = "";
      }
      if (url == "safetyCertificateImg") {
        this.signUpData.safetyCertificateImg = "";
      }
      if (url == "personImg") {
        this.signUpData.personImg = "";
      }
      if (url == "idCardFrontImg") {
        this.signUpData.idCardFrontImg = "";
      }
      if (url == "idCardBackImg") {
        this.signUpData.idCardBackImg = "";
      }
    },
    handleSafeSuccess(res, file) {
      this.$forceUpdate();
      this.signUpData.safetyCertificateImg = res.data;
    },
    handleFrontSuccess(res, file) {
      this.$forceUpdate();
      this.signUpData.idCardFrontImg = res.data;
    },
    handleBackSuccess(res, file) {
      this.$forceUpdate();
      this.signUpData.idCardBackImg = res.data;
    },
    handleAvatarSuccess(res, file) {
      this.$forceUpdate();
      this.signUpData.businessLicenseImg = res.data;
    },
    handlePersonSuccess(res, file) {
      this.$forceUpdate();
      this.signUpData.personImg = res.data;
    },
    handleMeberSuccess(res, file) {
      this.$forceUpdate();
      this.signUpData.vipFormImg = res.data;
    },
    handleRoadSuccess(res, file) {
      this.$forceUpdate();
      this.signUpData.transportLicenseImg = res.data;
    },
    handleAppointSuccess(res, file) {
      this.$forceUpdate();
      this.signUpData.appointmentImg = res.data;
    },
    beforeAvatarUpload(file) {
      let isJPG = file.type;
      let isLt2M = file.size / 1024 / 1024 < 0.2;
      // if(!isLt2M) {
      // 	this.$message.error('照片过大，请将图片大小压缩至200kb以下')
      // 	isLt2M = false;
      // }else{
      // 	isLt2M = true;
      // }
      if (
        file.type == "image/jpeg" ||
        file.type == "image/png" ||
        file.type == "image/JPG" ||
        file.type == "image/PNG"
      ) {
        isJPG = true;
      } else {
        this.$message.error("上传头像图片只能是JPG或者PNG格式!");
        isJPG = false;
      }
      if (isJPG) {
        return true;
      } else {
        return false;
      }
    },
    getMajorDataList() {
      majorTypeList({
        current: 1,
        pageSize: 30,
        professionalName: "",
      }).then((res) => {
        this.majorCategoryList = res.data.records;
      });
    },
    preImage() {
      const ViewerDom = document.getElementById("imgTooles");
      const viewer = new Viewer(ViewerDom, {
        url: "data-original",
      });
    },
    preImage2() {
      const ViewerDom = document.getElementById("imgTooles1");
      const viewer = new Viewer(ViewerDom, {
        url: "data-original",
      });
    },
    preImage11() {
      const ViewerDom = document.getElementById("imgToolesSafe");
      const viewer = new Viewer(ViewerDom, {
        url: "data-original",
      });
    },
    getDetail() {
      getSignUpDetail(this.$store.state.signUpRecordId).then((res) => {
        this.signUpData = res.data;
        this.getCompanyData(res.data.companyId);
      });
    },
    // 获取公司数据
    getCompanyData(vl) {

      this.memberPageId = vl
      getDetailCompany(vl).then((res) => {



          this.selectedOptions = [
          res.data.provinceName,
          res.data.cityName,
          res.data.countyName,
        ];


        console.log(this.selectedOptions);
        
  
        (this.pullAddress = [
          res.data.provinceName,
          res.data.cityName,
          res.data.countyName,
        ]),
          this.yingyeFileList.unshift(res.data.businessLicenseImg);
        this.memberFileList.unshift(res.data.vipFormImg);
        this.roadFileList.unshift(res.data.transportLicenseImg);
      });
    },
    // 修改公司数据
    updataCompany() {
      let arr =   this.signUpData.companyAddress.split(",");
      addCompany({
        companyId: this.memberPageId,
        businessAddress: this.signUpData.businessAddress,
        companyName: this.signUpData.companyName,
        creditCode: this.signUpData.creditCode,
        provinceName: arr.length!=0?arr[0]:this.pullAddress[0],
        provinceCode: arr.length!=0?arr[0]:this.pullAddress[0],
        cityName: arr.length!=0?arr[1]:this.pullAddress[1],
        cityCode: arr.length!=0?arr[1]:this.pullAddress[1],
        countyName: arr.length!=0?arr[2]:this.pullAddress[2],
        countyCode: arr.length!=0?arr[2]:this.pullAddress[2],
        businessLicenseImg: this.yingyeFileList[0],
        vipFormImg: this.memberFileList[0],
        transportLicenseImg: this.roadFileList[0],
        corp: this.signUpData.corp,
      }).then((res) => {
        if (res.code == 1) {
          this.$router.push("/SignUpRecord");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //清空
    handleClear() {
      // this.selectedOptions = [1];
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less">
.company-change-detail {
  font-size: 16px;
}

.company-text span {
  font-size: 16px;
}

.img-close-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 10;
  font-size: 20px;
  color: #eeeeee;
  font-weight: bold;
  cursor: pointer;
}
</style>
